import postmonger from 'postmonger';
import { jwtDecode } from 'jwt-decode';
import * as env from '@/config';
import { apiClient, setAuthorization } from '@/apis';
import axios from 'axios';
// import {
//   setCookie,
//   getAuthCookie,
// } from '@/utils/cookie';
import useUserStore from '@/stores/user';
import useDataStore from '@/stores/data';
import useComponentsStore from '@/stores/components';
import i18n from '@/i18n';
import apiErrorMessage from '@/utils/apiErrorMessage';
// import router from '@/router';

export const session = postmonger.Session();

export const config = {};
export const tempConfig = {};
export const endpoints = {};
export const enabledSchema = [];

const cache = new Map();

const initActivity = () => (new Promise((resolve, reject) => {
  const initActivityEvent = (data) => {
    console.debug('initialize:::start');
    console.debug(JSON.stringify(data));

    if (!data?.id?.length) {
      const { openAlertDialog } = useComponentsStore();

      const { promise } = openAlertDialog({
        title: 'notice',
        content: 'Please save the Journey first.',
      });

      promise.then(() => {
        session.trigger('updateActivity', data);
        session.trigger('nextStep');
        reject(new Error('Please save the Journey first.'));
      });

      return;
    }

    const {
      arguments: inArguments,
      metaData,
      configurationArguments,
      name,
      editable,
      errors,
      id,
      key,
      outcomes,
      schema,
      type,
    } = data;

    Object.entries(JSON.parse(JSON.stringify(data))).forEach(([k, v]) => {
      tempConfig[k] = v;
    });

    const messageActivityName = name || env.messageActivityName;

    resolve({
      inArguments,
      metaData,
      configurationArguments,
      messageActivityName,
      editable,
      errors,
      id,
      key,
      outcomes,
      schema,
      type,
    });

    session.off('initActivity', initActivityEvent);
    console.debug('initialize:::end');
  };

  const requestedTriggerEventDefinition = (data) => {
    config.dataExtensionName = data.dataExtensionName;
    session.off('requestedTriggerEventDefinition', requestedTriggerEventDefinition);
  };

  session.on('requestedTriggerEventDefinition', requestedTriggerEventDefinition);
  session.on('initActivity', initActivityEvent);

  session.trigger('requestTriggerEventDefinition');
  session.trigger('ready');
}));

const requestedEndpoints = () => (new Promise((resolve) => {
  const requestedEndpointsEvent = (data) => {
    console.debug('onGetEndpoints:::start');
    console.debug(JSON.stringify(data));

    cache.set('requestedEndpoints', data);
    resolve(data);

    session.off('requestedEndpoints', requestedEndpointsEvent);
    console.debug('onGetEndpoints:::end');
  };

  const temp = cache.get('requestedEndpoints');

  if (temp) {
    resolve(temp);
    return;
  }

  session.on('requestedEndpoints', requestedEndpointsEvent);
  session.trigger('requestEndpoints');

  if (env.mode === 'local') {
    const data = {
      fuelapiRestHost: env.fuelapiRestHost,
    };

    setTimeout(() => {
      cache.set('requestedEndpoints', data);
      resolve(data);
    }, 500);
  }
}));

const properEntrySource = async () => {
  const { openAlertDialog } = useComponentsStore();

  await openAlertDialog({
    title: 'Error',
    content: 'Please set the Proper Entry Source.',
  }).promise;
  // alert('Please set the Proper Entry Source.');

  session.trigger('updateActivity', tempConfig);
  session.trigger('nextStep');
  throw new Error('Please set the Proper Entry Source.');
};

const requestedTokens = () => (new Promise((resolve) => {
  const requestedTokensEvent = (data) => {
    console.debug('onGetTokens:::start');
    console.debug(JSON.stringify(data));

    const result = {
      ...data,
      MID: String(data.MID),
    };

    resolve(result);
    cache.set('requestedTokens', result);

    session.off('requestedTokens', requestedTokensEvent);
    console.debug('onGetTokens:::end');
  };

  const temp = cache.get('requestedTokens');

  if (temp) {
    resolve(temp);
    return;
  }

  session.on('requestedTokens', requestedTokensEvent);
  session.trigger('requestTokens');

  if (env.mode === 'local') {
    const data = {
      fuel2token: env.fuel2token,
      MID: env.mid,
    };

    setTimeout(() => {
      cache.set('requestedTokens', data);
      resolve(data);
    }, 500);
  }
}));

const requestedInteraction = () => (new Promise((resolve, reject) => {
  session.on('requestedInteraction', (journeySettings) => {
    console.debug('requestedInteraction:::start');
    console.debug(JSON.stringify(journeySettings));

    const availableEntrySource = [
      'DEAudience',
      'AutomationAud',
      'APIEvent',
      'SalesforceObjectTriggerV2',
      'CloudPagesSma',
      'DateEvent',
      'ContactAudience',
      'ContactEvent',
    ];

    const {
      name,
      version,
      id,
      definitionId,
      triggers,
    } = journeySettings;

    if (!triggers.length) {
      properEntrySource();
      reject(new Error('Please set the Proper Entry Source.'));
      return;
    }

    const [{ metaData: { eventDefinitionKey = '' } }] = triggers;

    if (!availableEntrySource.includes(eventDefinitionKey.split('-')[0])) {
      properEntrySource();
      reject(new Error('Please set the Proper Entry Source.'));
      return;
    }

    config.eventDefinitionKey = eventDefinitionKey;
    config.messageGroupName = name;
    config.messageGroupVersion = version;
    config.messageGroupId = id;
    config.messageGroupVersionId = definitionId;

    console.debug('requestedInteraction:::end');
    resolve();
  });

  session.trigger('requestInteraction');
}));

const requestedSchema = () => (new Promise((resolve) => {
  const requestedSchemaEvent = (data) => {
    console.debug('onGetSchema:::start');
    console.debug(JSON.stringify(data));

    resolve(data);

    session.off('requestedTokens', requestedSchemaEvent);
    console.debug('onGetSchema:::end');
  };

  session.on('requestedSchema', requestedSchemaEvent);
  session.trigger('requestSchema');
}));

const setData = async () => {
  await requestedInteraction();
  session.trigger('updateButton', { button: 'next', enabled: true });

  const data = await requestedSchema();

  const schema = data
    .schema
    .filter((item) => item.access !== 'Hidden')
    .map((item) => {
      if (item.key.indexOf('SalesforceObj') >= 0) {
        const [key1, key2, key3] = item.key.split('.');
        return { ...item, key: `${key1}."${key2}".${key3}"` };
      }

      const disabled = !!item.name.match(/[:-]|\s/);

      return {
        disabled,
        ...item,
      };
    });

  schema
    .filter(({ disabled }) => !disabled)
    .forEach(({ name }) => {
      enabledSchema.push(name);
    });

  if (!enabledSchema.length) {
    properEntrySource();
    return;
  }

  const { setDataExtensions, setActivityData } = useDataStore();
  setDataExtensions(schema);

  const temporaryDataExtension = {};

  schema.forEach((item) => {
    if (item.disabled) {
      return;
    }

    temporaryDataExtension[item.name] = item.key;
  });

  config.temporaryDataExtension = temporaryDataExtension;
  const cachedInArguments = config?.arguments?.execute?.inArguments[0];

  config.arguments.execute = {
    timeout: 10000,
    retryCount: 5,
    retryDelay: 10000,
    concurrentRequests: 10,
    url: env.executeUrl,
    verb: 'POST',
    format: 'json',
  };

  const configurationArguments = {
    applicationExtensionKey: config.configurationArguments.applicationExtensionKey,
    publish: {
      url: env.publishPath,
      useJwt: false,
      verb: 'POST',
    },
    validate: {
      url: env.validatePath,
      useJwt: false,
      verb: 'POST',
    },
  };

  config.configurationArguments = configurationArguments;

  if (!cachedInArguments?.messageType || !cachedInArguments?.templateId) {
    setActivityData({});
    return;
  }

  const {
    templateId,
  } = cachedInArguments;

  let res = {};

  try {
    res = await apiClient.get(`/template/${templateId}`);
  } catch (error) {
    apiErrorMessage(error, '메시지 정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.');
    throw new Error('message not found');
  }

  const {
    activityBasic: {
      // activityName,
      // journeyId,
      // journeyName,
      // journeyVersion,
      messageGroupVersionId: lastMessageGroupVersionId,
    },
    versionId,
    template: {
      rejectPhone,
      outgoingPhone,
      adult,
      departmentId: department,
      advert = {},
      failback = {},
      kakaoProfile,
      messageType,
      recipientNumberField: recipientNumber,
      redelivery,
      additionalFields,
      target: targetingSettings,
      // reserve,
      preTemplateId,
      pushNotification,
      personalizedField: personalizationFields,
      encryptType,
    },
  } = res;

  const initData = {
    templateId,
    outgoingPhone,
    rejectPhone,
    recipientNumber,
    department,
    messageType,
    isAdvert: advert?.enabled,
    redeliveryEnabled: redelivery?.enabled,
    additionalFields,
    lastMessageGroupVersionId,
    // reserve,
    fallback: failback,
    kakaoProfile,
    adult,
    data: res.template,
    versionId,
    preTemplateId,
    personalizationFields,
    targetingSettings,
    pushNotification,
    encryptType,
  };

  // set activity data store
  setActivityData(initData);

  // // set activity data page
  // const event = new CustomEvent('set-activity-data', { detail: initData });
  // window.dispatchEvent(event);

  config.templateId = templateId;
  config.lastMessageGroupVersionId = lastMessageGroupVersionId;
};

const setUserInfo = ({
  accessToken,
  fuel2token,
  mid,
}) => {
  const userStore = useUserStore();

  userStore.setUser({
    accessToken,
    fuel2token,
    mid,
  });
};

const tokenRefresh = async (mid) => {
  try {
    const response = await axios.post(`${env.mcApiUrl}/accounts/token`, null, {
      withCredentials: true,
    });

    const { accessToken, idToken } = response.data;
    const payload = jwtDecode(accessToken);

    if (mid === payload.organization_id) {
      sessionStorage.setItem('accessToken', accessToken);
      sessionStorage.setItem('idToken', idToken);

      setUserInfo({ accessToken });
      setAuthorization({ authorization: accessToken });
      return true;
    }

    return false;
  } catch (error) {
    return false;
  }
};

const checkSessionStorageTokenValid = (mid) => {
  const accessToken = sessionStorage.getItem('accessToken');

  if (!accessToken) {
    return false;
  }

  try {
    const payload = jwtDecode(accessToken);

    const exp = payload?.exp || 0;

    if (exp < Date.now() / 1000) {
      return false;
    }

    if (payload.organization_id === mid) {
      setUserInfo({ accessToken });
      setAuthorization({ authorization: accessToken });
      return true;
    }

    console.warn('organization id mismatch');
    sessionStorage.clear();
    return false;
  } catch (error) {
    return false;
  }
};

export const login = async () => {
  const [
    {
      fuelapiRestHost,
    },
    {
      fuel2token,
      MID: mid,
    },
  ] = await Promise.all([
    requestedEndpoints(),
    requestedTokens(),
  ]);

  if (checkSessionStorageTokenValid(mid)) {
    return;
  }

  if (await tokenRefresh(mid)) {
    return;
  }

  try {
    // login content type application/x-www-form-urlencoded
    const { accessToken, idToken } = await apiClient.post('/accounts/login', {
      fuelapiRestHost,
      fuel2token,
      mid,
    }, {
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    });

    if (accessToken) {
      sessionStorage.setItem('accessToken', accessToken);
      sessionStorage.setItem('idToken', idToken);
      setAuthorization({ authorization: accessToken });
    }

    setUserInfo({
      mid,
      fuel2token,
      accessToken,
    });
  } catch (error) {
    const { t } = i18n.global;
    const { openAlertDialog } = useComponentsStore();
    const errorCode = error?.response?.data?.errorCode;
    const trackingId = error?.response?.data?.trackingId;

    const alertContent = {
      title: t('alert.notification'),
      content: t('alert.unauthorized'),
      trackingId,
    };

    switch (errorCode) {
      case 'ERR_AUTH_001':
        alertContent.content = '비인가된 정보입니다. 잠시후 다시 시도하거나 관라지에게 문의하세요.';
        break;
      case 'ERR_AUTH_002':
        alertContent.content = '사용 정지된 시스템 계정입니다. 관리자에게 문의하세요.';
        break;
      case 'ERR_AUTH_003':
        alertContent.content = 'Salesforce 인증실패 입니다. 잠시후 다시 시도하세요.';
        break;
      case 'ERR_AUTH_004':
        alertContent.content = 'Salesforce 설정이 잘못되었습니다. 관리자에게 문의하세요.';
        break;
      case 'ERR_AUTH_005':
      case 'ERR_AUTH_999':
        alertContent.content = '인증서버 실패입니다. 관리자에게 문의하세요.';
        break;
      default:
        break;
    }

    openAlertDialog(alertContent)
      .promise
      .then(() => {
        session.trigger('updateActivity', tempConfig);
        session.trigger('nextStep');
        // session.trigger('destroy');
      });

    throw new Error('unauthorized');
  }
};

session.on('initActivityRunningHover', (data) => {
  config.type = 'hover';

  config.hoverData = data;
});

session.on('initActivityRunningModal', (data) => {
  config.type = 'running';

  config.runningData = data;
});

export const init = async () => {
  const {
    setActivityData,
    dataExtensions,
    setMessageActivityName,
  } = useDataStore();

  if (env.mode === 'local') {
    await login({
      fuelapiRestHost: env.fuelapiRestHost,
      fuel2token: env.fuel2token,
      mid: env.mid,
    });

    const temporaryDataExtension = {};

    Object.entries(dataExtensions).forEach(([key, item]) => {
      if (item.disabled) {
        return;
      }

      temporaryDataExtension[item.name] = key;
    });

    config.temporaryDataExtension = temporaryDataExtension;
    setMessageActivityName(env.messageActivityName);

    if (['details', 'result'].some((key) => window.location.pathname.match(key))) {
      return;
    }

    setActivityData({ messageType: 'SMS' });
    return;
  }

  const {
    inArguments,
    metaData,
    configurationArguments,
    messageActivityName,
    editable,
    errors,
    id,
    key,
    outcomes,
    schema,
    type,
  } = await initActivity();

  config.arguments = inArguments;
  config.metaData = metaData;
  config.configurationArguments = configurationArguments;
  config.messageActivityName = messageActivityName;
  config.name = messageActivityName;
  config.editable = editable;
  config.errors = errors;
  config.id = id;
  config.key = key;
  config.outcomes = outcomes;
  config.schema = schema;
  config.type = type;

  setMessageActivityName(messageActivityName || env.messageActivityName);
  await login();

  setData();
};
